<script>
import simplebar from "simplebar-vue";
import { authMethods } from "@/state/helpers";
export default {
  components: {
    simplebar,
  },
  data() {
    return {
      text: null,
      notifications: [],
      unread_notifications_count: 0,
      isMenuOpen: false,
      isMobileOrTablet: false,
    };
  },
  mounted() {
    this.checkScreen();
    window.addEventListener("resize", this.checkScreen);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreen);
  },
  methods: {
    ...authMethods,
    /**
     * Toggle menu
     */
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      this.$parent.toggleMenu();
    },
    checkScreen() {
      this.isMobileOrTablet = window.innerWidth < 769;
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    /**
     * Toggle rightsidebar
     */
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },

    logoutUser() {
      this.logOut();
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <!-- <img src="@/assets/images/logo-dark.png" alt height="20" /> -->
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <!-- <img src="@/assets/images/logo-light.png" alt height="20" /> -->
            </span>
          </router-link>
        </div>

        <button
          @click="toggleMenu"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn"
          id="vertical-menu-btn"
        >
        <i
          class="fa fa-fw"
          :class="
            isMobileOrTablet
              ? (isMenuOpen ? 'fa-times' : 'fa-bars')
              : 'fa-bars'
          "
        ></i>


        </button>
        <div class="px-4 d-flex flex-column justify-content-center"> 
          <h1 class="mb-0 text-dark f-24 fw-bold">Welcome, Admin</h1>
        <p class="mb-0 f-18">Streamlined Restaurant Curation for Omaha Food Lovers</p>
        </div>
      </div>

      <!-- Desktop Actions (shown on screens > 992px) -->
      <div class="d-none d-lg-flex justify-content-center align-items-center">
        <b-dropdown
          variant="white"
          class="d-none ms-2"
          toggle-class="header-item noti-icon"
          right
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
        >
          <template v-slot:button-content>
            <i class="uil-search"></i>
          </template>
          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('navbar.search.text')"
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>
       
        <div class="dropdown d-inline-block ms-1">
          <button
            type="button"
            class="btn header-item noti-icon waves-effect"
            data-toggle="fullscreen"
            @click="initFullScreen"
          >
            <i class="uil-minus-path w-28 h-28"></i>
          </button>
        </div>

        <b-dropdown
          variant="white"
          class="dropdown d-inline-block"
          toggle-class="header-item noti-icon"
          right
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
        >
          <template v-slot:button-content>
            <img src="@/assets/images/navNotification.svg" class="w-28">
            <span
              class="
                badge
                border border-warning border-white
                f-12
                p-1
                primaryColorBg
                rounded-circle
              "
              >{{ unread_notifications_count }}</span
            >
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h5 class="m-0 font-size-16">
                  {{ $t("navbar.dropdown.notification.text") }}
                </h5>
              </div>
              <div class="col-auto">
                <a href="#!" class="small">{{
                  $t("navbar.dropdown.notification.subtext")
                }}</a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px" data-simplebar>
            <div v-for="(notification, index) in notifications" :key="index">
              <a
                class="text-reset notification-item"
                href="javascript:void(0)"
                @click="readNotification(notification)"
              >
                <div
                  class="media"
                  :class="{ 'bg-body': notification.read_at == null }"
                >
                  <div class="media-body">
                    <h6 class="mt-0 mb-1">
                      {{ notification.data.subject }}
                    </h6>
                    <div class="font-size-12 text-muted">
                      <p class="mb-1">
                        {{ notification.data.message }}
                      </p>
                      <p class="mb-0">
                        <i class="mdi mdi-clock-outline"></i>
                        {{ formattedTime(notification.created_at) }}
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </simplebar>
          <div class="p-2 border-top">
            <div class="d-grid text-center">
              <!-- <router-link class="btn btn-sm btn-link font-size-14 " :to="isTeamMember() ? '/team-member-notifications' :'/notifications'">
                <i class="uil-eye me-1"></i>
                 View all 
               </router-link> -->
            </div>
          </div>
        </b-dropdown>

        <b-dropdown
          class="d-inline-block noti-icon"
          toggle-class="header-item"
          right
          variant="white"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <img src="@/assets/images/Union.png" width="28" height="28">
          </template>

          <a class="dropdown-item" style="cursor: pointer" @click="logoutUser">
            <i
              class="
                uil uil-sign-out-alt
                font-size-18
                align-middle
                me-1
                text-muted
              "
            ></i>
            <span class="align-middle">{{
              $t("navbar.dropdown.marcus.list.logout")
            }}</span>
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
<style scoped>
.w-28{
  width : 28px !important;
}
.uil-minus-path {
  font-size: 28px;
}
</style>